export const MarineInland = {
  codProducto: 'MARINEINLAND',
  urls: {
    datosLead: '/marine-inland1',
    ingresoEquipos: '/marine-inland2',
    opcionPago: '/marine-inland3',
    recuperar: '/recuperarcot-marineinland',
    emisionInfoEquipos: '/marine-infoequipos',
    emisionContratante: '/marine-emision-contratante',    
    vigenciaPoliza: '/vigencia-marine',
    // pagoPoliza: '/hogar-pago-poliza',
    // finCompra: '/hogar-fin-compra',
  }, 
};
